<template>
  <v-container fluid>
    <v-card>
      <v-card-title>
        <v-tabs grow>
          <v-tabs-slider color="green" />

          <v-tab @click="reportMode = 'contracts'">
            Договоры
          </v-tab>

          <v-tab @click="reportMode = 'monthly_report'">
            Помесячный отчёт
          </v-tab>
        </v-tabs>
      </v-card-title>

      <v-form ref="form" lazy-validation v-model="formRules.valid">
        <v-card-text>
          <v-row>
            <v-col cols="12" xs="12" sm="6" md="4" lg="4">
              <v-menu
                v-model="menuDate"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :value="formatedDate(filters.date)"
                    :rules="formRules.required"
                    label="Месяц"
                    prepend-icon="mdi-calendar"
                    readonly
                    clearable
                    v-bind="attrs"
                    v-on="on"
                    @click:clear="filters.date = null"
                  />
                </template>
                <v-date-picker
                  v-model="filters.date"
                  active-picker="YEAR"
                  :max="maxDateString"
                  min="2020-01-01"
                  locale="Ru-ru"
                  type="month"
                  @change="menuDate = false"
                />
              </v-menu>
            </v-col>

            <v-col v-if="reportMode === 'contracts'" cols="12" xs="12" sm="6" md="4" lg="4">
              <ContractSelector
                v-model="filters.contract"
                single
              />
            </v-col>

            <v-col v-if="reportMode === 'monthly_report'" cols="12" xs="12" sm="6" md="4" lg="4">
              <ProjectSelector
                v-model="filters.projects"
              />
            </v-col>

            <v-col v-if="reportMode === 'monthly_report'" cols="12" xs="12" sm="6" md="4" lg="4">
              <div class="grey--text text-caption mb-1">Выполнение нормы</div>
              <v-btn-toggle
                v-model="filters.normFulfilled"
                mandatory
                dense
                color="info"
              >
                <v-btn value="all">Все</v-btn>
                <v-btn value="below">Ниже нормы</v-btn>
                <v-btn value="above">Выше нормы</v-btn>
              </v-btn-toggle>
            </v-col>

            <v-col cols="12" align="right">
              <v-btn
                color="success"
                class="mt-3"
                @click="loadReport"
              >Поиск</v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-form>
    </v-card>

    <ContractReport v-if="reportMode === 'contracts'" :report="report" :loading="loading" />
    <MonthlyReport v-if="reportMode === 'monthly_report'" :report="report" :loading="loading" />
  </v-container>
</template>

<script>
import { requiredRule } from '~/plugins/rules'
import ContractSelector from '~/components/partials/selectors/ContractSelector.vue'
import ProjectSelector from '~/components/partials/selectors/ProjectSelector.vue'
import { mapActions } from 'vuex'
import axios from 'axios'
import moment from 'moment'
import ContractReport from './Report.vue'
import MonthlyReport from './MonthlyReport.vue'

export default {
  components: {
    ContractSelector,
    ProjectSelector,
    ContractReport,
    MonthlyReport,
  },
  data() {
    return {
      reportMode: 'contracts',
      menuDate: false,
      loading: false,
      report: {},
      filters: {
        date: '',
        contract: [],
        projects: [],
        normFulfilled: 'all',
      },
      formRules: {
        valid: false,
        required: requiredRule,
      },
    }
  },

  computed: {
    maxDateString() {
      return new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000).toISOString().substring(0, 10)
    },
  },

  methods: {
    ...mapActions({
      setError: 'shared/setError',
    }),

    async loadReport() {
      if (!this.$refs.form.validate()) return
      this.$store.commit('shared/SET_LOADING', true, {root: true});
      this.loading = true
      const payload = {
        // contract: this.filters.contract[0],
        // projects: this.filters.projects,
        month: this.filters.date,
      }

      if (this.reportMode === 'monthly_report') {
        payload.project_ids = this.filters.projects
        payload.norm_fulfilled = this.filters.normFulfilled
      } else if (this.reportMode === 'contracts') {
        payload.contract = this.filters.contract[0]
      }

      try {
        let url = '/api/reports/contracts'
        if (this.reportMode === 'monthly_report') url = '/api/reports/contracts/projects-monthly'

        const response = await axios.post(url, payload)
        this.report = response.data
      } catch (error) {
        this.report = {}
        let payload = {message: error}
        if (error?.response?.data) payload = error.response.data
        this.setError(payload)
      } finally {
        this.loading = false
        this.$store.commit('shared/SET_LOADING', false, {root: true});
      }
    },

    formatedDate(date) {
      return date ? moment(date).locale('ru').format('MMMM YYYY') : ''
    },
  },
}
</script>